import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import type { ContactFormData } from '@/types/contact';
import { contactFormSchema } from '@/schemas/contact';
import { contactService } from '@/services/contact';

export const useContactForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const form = useForm<ContactFormData>({
    resolver: zodResolver(contactFormSchema),
    defaultValues: {
      wedding_date: '',
      budget: undefined,
      first_name: '',
      partner_name: '',
      email: '',
      mobile: '',
      ceremony_location: '',
      wedding_county: '',
      message: ''
    }
  });

  const onSubmit = async (data: ContactFormData) => {
    try {
      setIsSubmitting(true);
      setSubmitError(null);
      await contactService.submitForm(data);
      setSubmitSuccess(true);
      form.reset();
    } catch (error) {
      setSubmitError('Failed to submit form. Please try again.');
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    form,
    isSubmitting,
    submitError,
    submitSuccess,
    onSubmit: form.handleSubmit(onSubmit)
  };
}; 